module.exports = __webpack_public_path__ + "static/media/d1ru.8e50baf9.pdf";